module.exports = __webpack_public_path__ + "img/2012-08-18 10.53.18.445d8388.jpg";